module.exports = __webpack_public_path__ + "static/img/AWTY_port_lg.7bc0d86.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/projects/are-we-there-yet-banner-campaign/AWTY_port_lg.jpg
// module id = 224
// module chunks = 2